import { AppProviders } from 'Features/app/AppProviders'
import { AppRoutes } from 'Features/app/routes'
import { MuiXLicense } from 'Features/app/MuiXLicence'

export const App = () => {
  return (
    <AppProviders>
      <MuiXLicense />
      <AppRoutes />
    </AppProviders>
  )
}
